import React, { useState, useMemo } from "react";
import RadioButton from "../RadioButton";
import RadioButtonGroup from "../RadioButtonGroup";
import LabelText from "./LabelText";

const RadioButtonVariantSet = (props) => {
    const {
        name,
        error,
        inputCacheValue,
        updateFormField,

        data,
        variant, // "normal", "card", "vertical"
    } = props;

    const [selectedValue, setSelectedValue] = useState(() => {
        if (inputCacheValue) {
            updateFormField(inputCacheValue);
            return inputCacheValue;
        }
        return "";
    });

    const onChange = (newValue) => {
        updateFormField(newValue);
        setSelectedValue(newValue);
    };

    const getRadioButtonGroupProps = () => {
        const commonRBGroupProps = {
            value: selectedValue,
            onChange: onChange,
            helperText: error || "",
            ...props,
        };
        if (variant === "vertical") {
            return {
                row: true,
                ...commonRBGroupProps,
            };
        }
        if (variant === "card") {
            return {
                card: true,
                ...commonRBGroupProps,
            };
        }
        // variant === "normal"
        return {
            ...commonRBGroupProps,
        };
    };
    const radioButtonGroupProps = getRadioButtonGroupProps();

    const renderRadioButtons = useMemo(() => data.map((radioButtonData, i) => {
        const {
            label,
            value,
            image,
        } = radioButtonData;

        const getRadioButtonProps = () => {
            const labelProp = (variant === "normal") ? label : (
                <React.Fragment>
                    <img src={image} alt={`${label}-img`} />
                    <LabelText text={label} />
                </React.Fragment>
            );
            const commonRadioButtonProps = {
                isChecked: selectedValue === value,
                value: value,
                label: labelProp,
            };

            if (variant === "vertical") {
                return {
                    vertical: true,
                    ...commonRadioButtonProps,
                };
            }
            if (variant === "card") {
                return {
                    card: true,
                    ...commonRadioButtonProps,
                };
            }
            // variant === "normal"
            return {
                ...commonRadioButtonProps,
            };
        };
        const radioButtonProps = getRadioButtonProps();
        return (
            <RadioButton
                key={i}
                {...radioButtonProps}
            />
        );
    }), [data, selectedValue, variant]);

    return (
        <RadioButtonGroup
            {...radioButtonGroupProps}
        >
            {renderRadioButtons}
        </RadioButtonGroup>
    );
};

export default RadioButtonVariantSet;